export const SurveyActionTypes = {
  SET_PROPERTY_UID_FOR_SURVEY: 'SET_PROPERTY_UID_FOR_SURVEY',
  SET_SURVEY_SCHEDULED_FOR: 'SET_SURVEY_SCHEDULED_FOR',
  SET_SURVEY_CREATED_AT: 'SET_SURVEY_CREATED_AT',
  SET_SURVEY_SERVICE_REQUESTED: 'SET_SURVEY_SERVICE_REQUESTED',
  SET_SURVEY_FROM_DATABASE: 'SET_SURVEY_FROM_DATABASE',
  SET_SURVEY_IMAGES: 'SET_SURVEY_IMAGES',
}
